module.exports = __webpack_public_path__ + "img/invoice_type_car.716ab3f2.png";